<ng-template #dialogMessageModal let-modal >
    <div id="modal-header" class="modal-header">
        <h5 class="modal-title">Avviso</h5>
        <button type="button" class="close" aria-label="Close" (click)="closeModal()">
            <app-toolkit-bl-icon icon="close"></app-toolkit-bl-icon>
        </button>
    </div>
    <div class="modal-body">
        <p *ngFor="let item of messages">
            <app-toolkit-bl-icon [icon]="item.icon || 'error'" [cssClass]="item.iconClassName || 'icon icon-sm'"></app-toolkit-bl-icon>
            <span [className]="item.className">{{ item.message }}</span>
        </p>
    </div>
    <div class="modal-footer">
        <button class="btn btn-outline-primary" type="button" (click)="closeModal()" tabindex="0">Chiudi</button>
    </div>
</ng-template>